module.exports = __webpack_public_path__ + "static/img/yijia.1cf0c672.png";